import React, { Fragment } from "react";
import ContentHeader from "../components/ContentHeader";
import UnallocatedCostsDataTable from "../components/UnallocatedCostsDataTable";

const Allocate = () => {
    const title = "Cost Allocation"
    return (
		<Fragment>
                <ContentHeader
					title={title}
				/>
				<div className="w-full">
					<UnallocatedCostsDataTable />
				</div>
                

		</Fragment>
	);
};

export default Allocate;